import React, { useState, useEffect, useRef } from "react";
import WorkflowCanvasView from "../Common Components/Workflow_CanvasView";
import WorkflowCanvas from "../Common Components/Workflow_Canvas";
import WorkflowCanvasEdit from "../Common Components/Workflow_CanvasEdit";
import PopupSubflowTemplate from "../PopupSubflowTemplate";
import WorkflowTemplateServiceController from "../../Controllers/WorkflowTemplateservice";
import "./Workflow Mapping.css";
import { useLocation, useNavigate } from "react-router-dom";
import CustomToaster, { notify } from "../Common Components/Custom_Toaster";
import CalloutNamePopup from "../Common Components/Event_Callotname_Popup";

const WorkflowMapping = () => {
  const [jobList, setJobList] = useState([]); // job dropdown list
  const [selectedJobId, setSelectedJobId] = useState(""); // selected job ID
  const [instanceName, setInstanceName] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const { state } = useLocation();
  const navigate = useNavigate();

  const isEdit = state?.mode === "edit";
  const editData = state?.workflowData;
  const [dropdownData, setDropdownData] = useState({
    client: "",
    department: "",
    workflowName: "--Select--",
    clientId: "",
    departmentId: ""
  });

  const [workflowNameList, setWorkflowNameList] = useState([]); // workflow template list
  const [workflowTempName, setWorkflowTempName] = useState("");
  const [subflowTempName, setSubflowTempName] = useState("");
  const [workFlowId, setWorkFlowId] = useState("0");
  const [versionId, setVersionId] = useState("0");
  const [jobTitle, setJobTitle] = useState("");

  const [json, setJson] = useState({ nodes: [], edges: [], dropdownData: {} });
  const [subJson, setSubJson] = useState({ nodes: [], edges: [], dropdownData: {} });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [subJsonData, setSubJsonData] = useState(null);

  const workflowCanvasRef = useRef(null);
  const subflowCanvasRef = useRef(null);
  const [isOpenCalloutNamePop, setIsOpenCalloutNamePop] = useState(false);
  const [calloutName, setCalloutName] = useState();

  const controller = new WorkflowTemplateServiceController();
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [note, setNote] = useState("");
  const editable = !state?.mode || state?.mode !== "view";


  const handleSubmitNote = () => {
    setNote(note);
    setShowNoteModal(false);
  };

  const loadJobList = async () => {
    try {
      let mode = 'add'; // ✅ use let
      if (isEdit || editData) {
        mode = 'edit';
      }
      const response = await controller.getworkflowMappingJobDropdownValues(mode);
      setJobList(response || []); // MUST BE array
    } catch (error) {
      console.error("Error loading job list:", error);
      setJobList([]); // avoid map crash
    }
  };

  const handleJobChange = (jobId) => {
    setSelectedJobId(jobId);
    const job = jobList.find((j) => j.id == jobId);
    if (job) {
      loadClientDeptWorkflow(job.title);
      setJobTitle(job.title);
    }
    setDropdownData((prev) => ({ ...prev, workflowName: "--Select--" }));
    setJson({ nodes: [], edges: [], dropdownData: {} });
  };

  const loadClientDeptWorkflow = async (jobTitle) => {
    try {
      const response = await controller.getworkflowMappingDropdownValues(jobTitle);

      // If API returns null, undefined, or empty object → reset everything
      if (!response || Object.keys(response).length === 0) {
        resetClientDeptWorkflow();
        return;
      }

      setDropdownData((prev) => ({
        ...prev,
        client: response.client || "",
        department: response.department || "",
        clientId: response.clientId || "",
        departmentId: response.departmentId || "",
        workflowName: "--Select--",
      }));
      setWorkflowNameList(response.workflowTemplate || []);
    } catch (error) {
      console.error("Error loading details:", error);
      resetClientDeptWorkflow();
    }
  };

  const GetWorkflowInstanceById = async (instanceId) => {
    try {
      const response = await controller.getWorkflowInstanceById(instanceId);
      // If API returns null, undefined, or empty object → reset everything
      //debugger;
      if (!response || Object.keys(response).length === 0) {
        resetClientDeptWorkflow();
        return;
      }
      setDropdownData((prev) => ({
        ...prev,
        client: response.client || "",
        department: response.department || "",
        clientId: response.clientId || "",
        departmentId: response.departmentId || "",
        id: response.workflowTemplateId,
        workflowName: String(response.workflowTemplateId),  // ✅ IMPORTANT
      }));
      const finalList = [
        { id: response.workflowTemplateId, calloutName: response.workflowName }
      ];
      setWorkflowNameList(finalList || []);
      setJson(response.instanceJsonData);
      //debugger;
    } catch (error) {
      console.error("Error loading details:", error);
      resetClientDeptWorkflow();
    }
  };
  const resetClientDeptWorkflow = () => {
    setDropdownData({
      client: "",
      department: "",
      clientId: "",
      departmentId: "",
      workflowName: "--Select--",
    });

    setWorkflowNameList([]);
    setJson({ nodes: [], edges: [], dropdownData: {} });
  };

  useEffect(() => {
    loadJobList();
  }, []);

  useEffect(() => {
    if (!isEdit || !editData || jobList.length === 0) return;
    // 1. Set Job
    setSelectedJobId(editData.jobId);
    setInstanceName(editData.instanceName);
    setCalloutName(editData.calloutName);
    const job = jobList.find(j => j.id == editData.jobId);
    if (!job) 
    {
      alert("Please check the selected Job should not Closed");
      return;
    }

    setJobTitle(job.title);
    // 2. Load client / department / workflow list
    const loadEditData = async () => {
      await GetWorkflowInstanceById(editData.id);
    };

    loadEditData();

  }, [isEdit, editData, jobList]);

  useEffect(() => {
    if (!isEdit || !editData || workflowNameList.length === 0)
      return;

    handleWorkflowChange(editData.workflowTemplateId);
  }, [workflowNameList, isEdit, editData]);

  const handleWorkflowChange = async (selectedId) => {
    setWorkFlowId(selectedId);
    setDropdownData((prev) => ({ ...prev, workflowName: selectedId }));
    if (selectedId === "--Select--") {
      setJson({ nodes: [], edges: [], dropdownData: {} });
      setWorkflowTempName("");
      return;
    }

    // Find the selected template object   
    const template = workflowNameList.find((t) => t.id == selectedId);
    if (!template) return;
    setWorkflowTempName(template.calloutName);
    setVersionId(template.version);
    if (template.templateData) {
      setJson({
        nodes: template.templateData.nodes || [],
        edges: template.templateData.edges || [],
        dropdownData: {
          client: dropdownData.client,
          department: dropdownData.department,
        },
      });
    }
    // if (selectedId !== "0") {
    //   const versionDropdowns = await controller.getWorkflowTemplateDropdownValuesVersion(selectedId);
    //   setVersion(
    //     Array.isArray(versionDropdowns) && versionDropdowns.length > 0
    //       ? [
    //         { label: "--select--", value: "0" }, // ✅ default first option
    //         ...versionDropdowns
    //           .sort((a, b) => Number(b.versionId) - Number(a.versionId)) // DESC
    //           .map((item) => ({
    //             label: item.versionId,
    //             value: item.versionId,
    //           })),
    //       ]
    //       : [{ label: "--select--", value: "0" }]
    //   );
    // }
    //reloadWorkflowTemplateCanvas();
    //reloadSubflowTemplateCanvas();
    
  };
  const handleSaveInputCalloutName = async () => {
    setIsOpenCalloutNamePop(false);
    const templateId = dropdownData.workflowName;
    const workflowInstance = {
      jobId: selectedJobId,
      workflowTemplateId: templateId,
      clientId: dropdownData.clientId,
      departmentId: dropdownData.departmentId,
      instanceJsonData: json,
      workflowName: dropdownData.workflowName,
      jobTitle: jobTitle,
      notes: note,
      calloutName: calloutName ?? "",
    };
    try {
      setIsSaving(true);
      const response = await controller.postworkflowMappingInstance(workflowInstance);
      if (response > 0) {
        await notify(`The mapping has been successfully saved.`, true)
        navigate("/workflowinstance");
      }
      else {
        await notify(`An error occurred while saving the mapping.`, false)
      }
    } catch (err) {
      setIsSaving(false);
      console.error("Save error:", err);
      await notify(`An error occurred while saving the mapping.`, false);
    }
  }
  const handleSave = async () => {
    if (isSaving) return;
    const templateId = dropdownData.workflowName;
    if (!selectedJobId || templateId === "--Select--") {
      await notify(`Please select Workflow Template.`, true);
      return;
    }
    setIsOpenCalloutNamePop(true);

  };

  const handleUpdate = async () => {
    if (isSaving) return;

    // Get latest workflow JSON from the canvas
    //const updatedJson = workflowCanvasRef.current.getViewData(); 
    const updatedJson = workflowCanvasRef.current.exportToJson();

    if (!updatedJson) {
      await notify("No workflow data available.", false);
      return;
    }
    var exportedJsonData = JSON.parse(updatedJson);
    const workflowInstance = {
      id: editData.id,
      jobId: String(selectedJobId),
      workflowTemplateId: String(dropdownData.workflowName),
      workflowName: String(dropdownData.workflowName),
      clientId: dropdownData.clientId,
      departmentId: dropdownData.departmentId,
      instanceJsonData: exportedJsonData,
      jobTitle: jobTitle,
      notes: note,
      calloutName: calloutName ?? "",
    };

    try {
      setIsSaving(true);
      const response = await controller.postworkflowMappingInstance(workflowInstance);

      if (response > 0) {
        await notify("The mapping has been successfully Updated.", true);
        navigate("/workflowinstance");
      } else {
        await notify("Update failed.", false);
      }
    } catch (err) {
      setIsSaving(false);
      console.error("Update error:", err);
    }
  };

  const handleNodeSelection = async (node) => {
    const levelId = node?.data?.levelId;
    const workflowTempId = dropdownData.workflowName;
    if (!levelId || !workflowTempId) return;
    await getSubflowTemplateByworkflowId(workflowTempId, levelId);
  };

  const getSubflowTemplateByworkflowId = async (templateId, levelId) => {
    try {
      const res = await controller.getNodeDataByTemplateId(templateId, levelId, versionId);
      console.log(res);
      if (!res || res.length === 0) {
        setSubJson({ nodes: [], edges: [], dropdownData: {} });
        await notify(`  No subflow template has been created yet for this skill level.`, false)
        return;
      }

      const item = res[0];
      setSubflowTempName(item.templateName_SubFlow);

      setSubJson({
        nodes: item.templateData?.nodes || [],
        edges: item.templateData?.edges || [],
        dropdownData: {
          client: item.templateData?.dropdownData.client,
          department: item.templateData?.dropdownData.department,
        },
      });

      if (subJson) {
        setSubJsonData(subJson);
        setIsPopupOpen(true);
      } else {
        // Handle case if no subJson exists for clicked node
        setSubJsonData(null);
        setIsPopupOpen(false);

      }
    } catch (err) {
      console.error("Subflow load error:", err);
    }
    reloadSubflowTemplateCanvas();
    reloadWorkflowTemplateCanvas();
  };
  useEffect(() => {


  }, [subJson][subJsonData]);

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    reloadWorkflowTemplateCanvas();


  };
  const [reloadWorkflowTemplate, setReloadWorkflowTemplate] = useState(0);
  const [reloadSubflowTemplate, setReloadSubflowTemplate] = useState(0);


  const reloadWorkflowTemplateCanvas = () => {
    setReloadWorkflowTemplate(prev => prev + 1);
  };
  const reloadSubflowTemplateCanvas = () => {
    setReloadSubflowTemplate(prev => prev + 1);
  };
  const [version, setVersion] = useState([
    { label: "--Select--", value: "0" },
  ]);

  const handleVersionChange = async (selectedValue) => {
    const body = await controller.getVersionTemplateByTemplateId(workFlowId, selectedValue);
    const localJson = body.templateData;
    setJson(localJson); // ✅ update state
    reloadWorkflowTemplateCanvas();
  };
  const handleInputChange = (event) => {
    setCalloutName(event.target.value);
  };
  const onClose = () => {
    setIsOpenCalloutNamePop(false);
  };
  return (
    <>
      {/* Top Filters */}
      <div className="workflow-filters-title">
        <div>
          <label> {isEdit
            ? "Edit Workflow Mapping with '" + instanceName + "'"
            : "Create Workflow Mapping"}
          </label>
        </div>

        {/* Save Button Row */}
        <div className="save-button-container">
          <button
            className="save-btn"
            onClick={isEdit ? handleUpdate : handleSave}
            disabled={
              isSaving ||
              !selectedJobId ||
              dropdownData.workflowName === "--Select--"
            }
          >
            {isSaving
              ? isEdit
                ? "Updating..."
                : "Saving..."
              : isEdit
                ? "Update"
                : "Save"}
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="workflow-filters">
        <div>
          <label>Job Title</label>
          <select
            className="top-input"
            value={selectedJobId}
            onChange={(e) => handleJobChange(e.target.value)}
            disabled={isEdit && !!editData}
          >
            <option value="">-- Select Job --</option>
            {jobList.map((job) => (
              <option key={job.id} value={job.id}>
                {job.title}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Client</label>
          <input className="top-input" disabled value={dropdownData.client} />
        </div>

        <div>
          <label>Department</label>
          <input className="top-input" disabled value={dropdownData.department} />
        </div>


        <div>
          <label>Workflow Template</label>
          <select
            className="top-input"
            value={dropdownData.workflowName}
            onChange={(e) => handleWorkflowChange(e.target.value)}
            disabled={isEdit && !!editData}
          >
            <option value="--Select--">--Select--</option>
            {workflowNameList.map((wf) => (
              <option key={wf.id} value={wf.id}>
                {wf.calloutName + "(V" + wf.version + ")"}
              </option>
            ))}
          </select>
        </div>
        {/*    <div style={{ display: "flex", flexDirection: "column" }}>
          <label>Version</label>
          {Array.isArray(version) && version.length > 0 ? (
            <select
              onChange={(e) => handleVersionChange(e.target.value)}
              style={{
                flex: 1,
                padding: "6px 10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "100%",
              }}
            >
              {version.map((event) => (
                <option key={event.value} value={event.value}>
                  {event.label}
                </option>
              ))}
            </select>
          ) : (
            <p>No versions available</p>
          )}
        </div>  */}
        <button
          className="add-note-btn"
          style={{
            padding: "8px 16px",
            color: "#02ACF6",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            alignSelf: "flex-end",
            fontWeight: "600",
          }}
          onClick={() => setShowNoteModal(true)}
          disabled={dropdownData.workflowName === "--Select--"}
        >
          + Add Note
        </button>
      </div>

      {/* CANVAS */}
      {dropdownData.workflowName !== "--Select--" && (

        <div className="canvas-wrapper">
          <WorkflowCanvasView
            key={`${dropdownData.workflowName}-${reloadWorkflowTemplate}-1`}
            ref={workflowCanvasRef}
            json={json}
            dropdownData={dropdownData}
            isSubflow={false}
            workflowName={workflowTempName}
            editable={false}
            isTransaction={false}
            onParentNodeClick={handleNodeSelection}
          />
        </div>

        //  <div className="canvas-wrapper">
        //   <div className="canvas-container"> 
        //     <WorkflowCanvasView
        //       key={`${dropdownData.workflowName}-${reloadWorkflowTemplate}-1`}
        //       ref={workflowCanvasRef}
        //       json={json}
        //       dropdownData={dropdownData}
        //       isSubflow={false}
        //       workflowName={workflowTempName}
        //       editable={false}
        //       isTransaction={false}
        //       onParentNodeClick={handleNodeSelection}
        //       fitView
        //     />
        //   </div>

        //   <div className="canvas-container">

        //     <WorkflowCanvasView
        //       key={`${dropdownData.client}-${reloadSubflowTemplate}-2`}
        //       ref={subflowCanvasRef}
        //       json={subJson}
        //       dropdownData={dropdownData}
        //       isSubflow={true}
        //       workflowName={subflowTempName}
        //       editable={false}
        //       isTransaction={false}
        //       fitView
        //     />
        //   </div>
        // </div>

      )}
      {isPopupOpen && (
        <PopupSubflowTemplate
          json={subJson}
          onClose={handleClosePopup}
          subflowTempName={subflowTempName}
        />
      )}
      <CustomToaster />

      {showNoteModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Add Note</h3>
            <p className="modal-subtitle">
              Once you add a note it will show in Workflow Instances grid screen
            </p>

            <textarea
              className="note-input"
              placeholder="Enter Note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />

            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowNoteModal(false)}
              >
                Cancel
              </button>
              <button
                className="submit-btn"
                onClick={handleSubmitNote}
                disabled={!note.trim()}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      <CalloutNamePopup
        open={isOpenCalloutNamePop}
        onClose={onClose}
        onSave={handleSaveInputCalloutName}
        handleInputChange={handleInputChange}
      />
    </>
  );
};

export default WorkflowMapping;
